import React, {
    CSSProperties,
    Dispatch,
    PropsWithChildren,
    SetStateAction,
} from 'react';
import { IconActionButton } from './IconActionButton';

interface IClearFieldsButtonProps extends PropsWithChildren<any> {
    isLoaded: boolean;
    clearAllFields?: () => void;
}

const divStyles: CSSProperties = {
    marginTop: '5px',
    marginLeft: '5px',
    marginRight: '5px',
};

export const ClearFieldsButton: React.FC<IClearFieldsButtonProps> = (
    props: IClearFieldsButtonProps
) => {
    return (
        <div className={'DefaultHubButton-root'} style={divStyles}>
            <IconActionButton
                setDisabled={!props.isLoaded}
                setDisabledOnSuccess={false}
                onClick={() => {
                    props.clearAllFields?.();
                    return Promise.resolve();
                }}
                initialButtonText={'Clear Fields'}
                initialButtonIcon={'Cancel'}
                showConfirmationPopup={false}
                iconName={'Cancel'}
                disableState={true}
                iconColor={'red'}
                onHover={'red'}
                toolTipText="Clear all filters"
            />
        </div>
    );
};
